import * as React from "react";
import { createLink, type LinkComponent } from "@tanstack/react-router";
import * as Mantine from "@mantine/core";

type SafeMantineButtonLinkProps =
  React.AnchorHTMLAttributes<HTMLAnchorElement> & Mantine.ButtonProps;

const SafeMantineButtonLink = React.forwardRef<
  HTMLAnchorElement,
  SafeMantineButtonLinkProps
>((props, ref) => {
  return <Mantine.Button component="a" ref={ref} {...props} />;
});

const CreatedSafeMantineButtonLink = createLink(SafeMantineButtonLink);

export const ButtonLink: LinkComponent<typeof CreatedSafeMantineButtonLink> = (
  props,
) => {
  return <CreatedSafeMantineButtonLink preload="intent" {...props} />;
};
